module.exports = __webpack_public_path__ + "static/media/280.c9ab9c78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/280.jpg
// module id = 970
// module chunks = 0